import { safeDefine } from "../../registration/safe-define.js";
import { ScaffoldVideoSkinElement } from "../../presets/video/scaffold-skin.js";
import "../../internal/skins/scaffold-video/register.js";
//#region src/define/video/scaffold-skin.ts
safeDefine(ScaffoldVideoSkinElement);
//#endregion
